<template>
  <div>
    <div class="courseList-module" v-for="(item, i) in courseList">
      <div class="courselist-item">
        <p class="fl pl10 font14px">第{{i+1}}章　{{item.name}}</p>
        <!-- 点击编辑按钮显示编辑输入框 -->
        <p class="fr review_message">
          
          <el-switch
              v-if="item.checkStatus == 1 || item.checkStatus ==2 || item.checkStatus ==''"
              :width="50"
              class="mr10 fl mt12"
              v-model="item.checkStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value=2
              inactive-value=1
              @change="checkPass(item)"
          >
          </el-switch>
          <el-switch
              v-if="item.checkStatus == 3 || item.checkStatus ==4"
              :width="50"
              class="mr10 fl mt12"
              v-model="item.checkStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value=4
              inactive-value=3
              @change="checkPass(item)"
          >
          </el-switch>
        </p>
      </div>
      <div class="courseList-module2" v-for="(item2, j) in item.nodes">
        <div :class="typeof item2.resourceModel!='undefined' ? 'courselist-item showItem hasSource' : 'courselist-item '  "
             @click="typeof item2.resourceModel!='undefined' ? detail(item2.resourceModel, item2.id):detail" @mouseenter="showIcon(i + '' + j)" @mouseleave="hideIcon()">
          <p class="fl pl30 font14px" v-show="editInptIndex2 != (i + '' + j)">
            <span class="fl wid37" style="width: 60px">课时{{j+1}}</span>
            <span class="yuan"></span>{{item2.name}}</p>
          
          <p class="fr review_message">
            <el-switch
                v-if="item2.checkStatus == 1 || item2.checkStatus ==2"
                :width="50"
                class="mr10 fl mt12"
                v-model="item2.checkStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value=2
                inactive-value=1
                @change="checkPass(item2)"
            >
            </el-switch>
            <el-switch
                v-if="item2.checkStatus == 3 || item2.checkStatus ==4"
                :width="50"
                class="mr10 fl mt12"
                v-model="item2.checkStatus"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value=4
                inactive-value=3
                @change="checkPass(item2)"
            >
            </el-switch>
            <el-button v-if="item2.checkStatus == 1 " @click="reason()"
                       class="icon iconfont icondelete1 hand fl mt3 ml30" type="text">
                <el-tooltip class="item" effect="dark" :content="item2.checkResult | result" placement="top">
                  <span>原因</span>
                </el-tooltip>
            </el-button>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 0"
               class="icon-blcu-ceshi1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)==current">测试</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 1"
               class="icon-blcu-zuoye fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">作业</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 2"
               class="icon-blcu-shipin fr mr20" ><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">视频</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 3"
               class="icon-blcu-zhibobofangshexiangjitianxianxianxing fr mr20">
              <span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)==current">直播</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 4"
               class="icon-blcu-taolun1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">讨论</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 5"
               class="icon-blcu-wenda fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">问答</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 6"
               class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">文档</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 7"
               class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">文本</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 8"
               class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">资料</span></i>
            <i v-if="item2.resourceModel != null &&item2.resourceModel.resourceType == 9"
               class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j)===current">网页</span></i>

          </p>
        </div>
        <div class="courseList-module3" v-for="(item3, k) in item2.nodes">
          <div :class="typeof item3.resourceModel!='undefined' ? 'courselist-item showItem hasSource' : 'courselist-item ' "
               @click="typeof item3.resourceModel!='undefined' ? detail(item3.resourceModel, item3.id):detail" @mouseenter="showIcon(i+''+j+''+k)" @mouseleave="hideIcon()">
            <p class="fl pl30 font14px">
              <span class="yuan"></span>{{item3.name}}</p>
            <p class="fr review_message">
              <el-switch
                  v-if="item3.checkStatus == 1 || item3.checkStatus == 2"
                  :width="50"
                  class="mr10 fl mt12"
                  v-model="item3.checkStatus"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value=2
                  inactive-value=1
                  @change="checkPass(item3)"
              >
              </el-switch>
              <el-switch
                  v-if="item3.checkStatus == 3 || item3.checkStatus == 4"
                  :width="50"
                  class="mr10 fl mt12"
                  v-model="item3.checkStatus"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-value=4
                  inactive-value=3
                  @change="checkPass(item3)"
              >
              </el-switch>
              <el-button v-if="item3.checkStatus == 1 "
                         class="icon iconfont icondelete1 hand fl mt3 ml30" type="text" @click="reason()">
                <el-tooltip class="item" effect="dark" :content="item3.checkResult | result" placement="top">
                  <span>原因</span>
                </el-tooltip>
              </el-button>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 0"
                 class="icon-blcu-ceshi1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)==current">测试</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 1"
                 class="icon-blcu-zuoye fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">作业</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 2"
                 class="icon-blcu-shipin fr mr20" ><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">视频</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 3"
                 class="icon-blcu-zhibobofangshexiangjitianxianxianxing fr mr20">
                <span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)==current">直播</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 4"
                 class="icon-blcu-taolun1 fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">讨论</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 5"
                 class="icon-blcu-wenda fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">问答</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 6"
                 class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">文档</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 7"
                 class="icon-blcu-wenben fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">文本</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 8"
                 class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">资料</span></i>
              <i v-if="item3.resourceModel != null &&item3.resourceModel.resourceType == 9"
                 class="icon-blcu-ziliao fr mr20"><span style="float: left; font-size: 15px; margin-right: 5px;" v-if="seen&&(i+''+j+''+k)===current">网页</span></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

</div>
</div>
</transition>


</div>

</div>
</template>

<script>

  import https from '@/https.js';

  export default {
    name: 'CourseTree',
    props: ['courseId', 'catalogId', 'isNextStep'],
    data() {
      return {
        dialogFormVisible: false,
        isShowChooseBtn: true,
        courseList: [],
        textarea: '', //视频描述
        videoinput: '', //视频名称
        addFlagIndex: '', // 添加目录显示标记
        isShow: false,
        pickerOptions: { //时间组件
          disabledDate(time) {
            return time.getTime() <= Date.now();
          }
        },
        isReview: false,
        fileList: [],
        fileDocList: [],
        activeName: 'step1',
        options: [],
        options2: [],
        addCharpetinput: '', //添加章节INPUT值
        editInptIndex: -1, //编辑INPUT框标记
        editInptIndex2: -1, //编辑INPUT框标记
        editInptIndex3: -1, //编辑INPUT框标记
        editName: '', //编辑章input的model值
        courseName: '',
        resourceName: '', // 文件名称
        fileInput: '', // 文件名称输入框
        valueTypeA: '', //所属类目select
        valueTypeB: '',
        checkList: [], //添加步骤checkbox
        radioType: '直播',
        valueTime: '', //直播时间
        valuetime1: '',
        valuetime2: '',
        value: '',
        valueDate: '',
        courseNum: '-1', //章节标记控制hover
        addLearnNum: '-1', //添加学习任务标记
        currentRoomId: '', // 当前编辑项的roomid
        resourcesId: '', //当前编辑的资源Id
        currentEditor: null,
        seen: '',
        current: '',
        //resourcesId:'' //修改富文本传的ID
      };

    },
    methods: {
      reason() {
        this.stopBubble();
      },

      checkPass(row) {
        let checkStatus = row.checkStatus;
        if (checkStatus == 1) {
          row.checkStatus = "3";
        }

        if (checkStatus == 2 ) {
          row.checkStatus = "4";
        }

        console.log(row.checkStatus)
        let params = { // 0 目录 1资源
          courseId: this.courseId,
          resourceId: row.id,
          resourceType: 0,
          checkStatus: row.checkStatus
        };
        https.fetchPost('/courseCheck/checkPass', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
        this.stopBubble();
      },

      stopBubble(e) {
        if ( e && e.stopPropagation ){
          //因此它支持W3C的stopPropagation()方法
          e.stopPropagation();
        }else{
          //否则，我们需要使用IE的方式来取消事件冒泡
          window.event.cancelBubble = true;
        }
      },
      
      detail(resourceModel, id) {
        if(!resourceModel) {
          return;
        }
        if(resourceModel.resourceType ===3 ) {
          this.$message({
            type: 'info',
            message: '直播课程无需审核'
          });
        } else {
          let params = {
            courseId: this.courseId,
            catalogId: id,
            resourceType: resourceModel.resourceType,
            resourceId: resourceModel.resourcesId,
            detail: 2
          };
          this.$emit("detailChanged",params);
        }
        

      },
      showIcon(index) {
        this.seen = true;
        this.current = index;

      },
      
      hideIcon(index) {
        this.seen = false;
        this.current = null;
      },
      //获取目录结构
      getKnowledgePoints2() {
        let params = {
          'courseId': this.courseId,
          'userType': 'M',  //M 管理员,
          'status': 1
        };
        https.fetchPost('/catalog/getCourseCatalog', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.courseList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      }


    },
    filters: {
      result(val) {
        return "标题内容"+val;
      }
    },
    created: function() {
      if (this.courseId) {
        this.getKnowledgePoints2();
      }
    }

  };
</script>

<style scoped>

  .hasSource {
    cursor: pointer;
  }
</style>
